exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".profile-panel[data-v-5556d924]{padding-top:200px}.profile-panel .user-info[data-v-5556d924]{padding:0 50px;color:#fff}.profile-panel .user-info .full_name[data-v-5556d924]{text-transform:uppercase;margin:0;margin-bottom:10px}.profile-panel .user-info h3[data-v-5556d924]{margin:0;line-height:1.5}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5556d924","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/layout/ProfilePanel.vue
// module id = odA6
// module chunks = 0 1